import { useRouter } from 'next/router'
import classNames from 'classnames'
import { TStrapiV4BreadcrumbWidget } from '../../common-types'
import BreadCrumb from '@/stories/components/Common/BreadCrumbs'
import BackArrow from '@/assets/PageHeader/Back.inline.svg'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import useIsInApp from '@/hooks/use-is-in-app'
import { handleNavigationBack } from '@/root/utils/webview/navigation-back'

type TProps = TStrapiV4BreadcrumbWidget & { notHero?: boolean }

export function StrapiV4BreadcrumbWidget(props: TProps) {
  const {
    back_button_required,
    back_button_link,
    breadcrumb_single,
    // pinned_to_top,
    add_instocks_logo,
    notHero,
  } = props

  const isInApp = useIsInApp()

  const router = useRouter()

  const navigateBack = () => {
    if (back_button_link) {
      void router.push(back_button_link)
    } else if (isInApp) {
      handleNavigationBack()
    } else {
      router.back()
    }
  }

  return (
    <div
      className={classNames(
        'bg-brand-white w-full',
        // {
        // 'sticky top-[85px] z-10': pinned_to_top,
        // }
      )}
    >
      <div
        className={classNames('flex items-center justify-between', {
          'herolike-wrapper': !notHero,
        })}
      >
        <div className="flex items-center py-2.5">
          {back_button_required && (
            <BackArrow
              className="mr-3 cursor-pointer"
              height="20"
              width="20"
              onClick={navigateBack}
            />
          )}
          {!isInApp && (
            <BreadCrumb
              structuredSchemaInHTML
              breadCrumbList={breadcrumb_single?.map(item => {
                return {
                  label: item.label,
                  link: item.relative_path,
                }
              })}
            />
          )}
        </div>
        {add_instocks_logo && (
          <div className="hidden lg:block">
            <StencilCDNImage
              src="https://indcdn.indmoney.com/cdn/images/fe/indstocks-logo.png"
              alt="INDstocks by INDmoney"
              width={100}
              height={33}
            />
          </div>
        )}
      </div>
    </div>
  )
}
